/* eslint-disable no-throw-literal */
import { instance } from "../apiBase/instance";

interface LoginRequest {
  email: string;
  password: string;
}

interface RegisterRequest {
  email: string;
  password: string;
  name: string;
}

interface AuthResponse {
  success: boolean;
  data: {
    user: {
      id: string;
      email: string;
      name: string;
    };
    token: string;
  };
  message?: string;
}

export const AuthApi = {
  async Login(data: LoginRequest): Promise<AuthResponse> {
    try {
      const response = await instance.post('/api/auth/login', {
        email: data.email,
        password: data.password,
      });

      const responseData = response.data;

      return {
        success: true,
        data: {
          user: {
            id: responseData.user.id || '',
            email: responseData.user.email || data.email,
            name: responseData.user.name || '',
          },
          token: responseData.access_token,
        },
        message: 'Login success',
      };
    } catch (error: any) {
      // Xử lý lỗi từ API
      if (error.status) {
        throw {
          status: error.status,
          message: error.message || 'Login failed',
        };
      }
      throw {
        status: 500,
        message: error.message || 'An error occurred during login',
      };
    }
  },

  async Register(data: RegisterRequest): Promise<AuthResponse> {
    // API giả lập cho Register - sẽ được thay thế bằng API thật sau
    const mockDelay = (ms: number = 1000) => new Promise(resolve => setTimeout(resolve, ms));
    const mockUsers: Array<{ email: string; password: string; name: string; id: string }> = [
      { id: '1', email: 'admin@example.com', password: 'admin123', name: 'Admin User' },
      { id: '2', email: 'user@example.com', password: 'user123', name: 'Test User' },
    ];

    // Giả lập delay network
    await mockDelay(1000);

    // Kiểm tra email đã tồn tại chưa
    const existingUser = mockUsers.find((u: { email: string; password: string; name: string; id: string }) => u.email === data.email);

    if (existingUser) {
      throw {
        status: 400,
        message: 'Email already exists',
      };
    }

    // Validate password
    if (data.password.length < 6) {
      throw {
        status: 400,
        message: 'Password must be at least 6 characters',
      };
    }

    // Tạo user mới
    const newUser = {
      id: String(mockUsers.length + 1),
      email: data.email,
      password: data.password,
      name: data.name,
    };

    mockUsers.push(newUser);

    // Tạo token giả lập
    const token = `mock_token_${newUser.id}_${Date.now()}`;

    return {
      success: true,
      data: {
        user: {
          id: newUser.id,
          email: newUser.email,
          name: newUser.name,
        },
        token,
      },
      message: 'Register success',
    };
  },
};

